import {ParticipantsList} from "./presentation/ParticipantsList";
import {useParticipants} from "./usePaticipants";
import React from "react";

export const ParticipantsContainer = () => {
    return <ParticipantsList data={useParticipants()} />
}
